import React, { Component } from "react";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import QueryCardList from "../Query/QueryCardList";
import LightModePageTemplate from "../page/Templates/LightModeTemplate";
import SideBarTemplate from "../side-bar/SideBarTemplate";
import BulletinPanel from "../BulletinPanel/BulletinPanel";
import QueryGridSidePanel from "./QueryGridSidePanel";
import QueryGrid from "./QueryGrid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle,faSync } from "@fortawesome/pro-regular-svg-icons";
import GridTitleCard from "../Cards/GridTitleCard";
import { faUserCog } from "@fortawesome/pro-solid-svg-icons";

interface QueryGridPageProps extends RouteComponentProps {
    title: string;
    category: string;
    location: any;
    queryId: string;
}

interface QueryGridPageState {
    clientId: string,
    venueId: string,
    serviceId: string,
    statusId: string,
    raisedById:string,
    isRefreshButtonClicked :boolean
}

class QueryGridPage extends Component<QueryGridPageProps> {
    //Initialize the State
    state: QueryGridPageState;

    constructor(props: QueryGridPageProps) {
        super(props);

        this.state = {
            clientId: "",
            venueId: "",
            serviceId: "",
            statusId: "",
            raisedById:"",
            isRefreshButtonClicked:false
        };
    }

    onApplyButtonClick = (clientId: string, venueId: string, serviceId: string, statusId: string,raisedById:string,isApplyClicked:boolean) => {
        if (isApplyClicked && this.props?.location?.state) {
            this.props.location.state = {};
        }
        this.setState({
            clientId: clientId,
            venueId: venueId,
            serviceId: serviceId,
            statusId: statusId,
            raisedById:raisedById
        });
    }
    // onRefreshRequest = () => {
    //     this.setState({isRefreshButtonClicked: true});
    // }
    onRefresh = (isRefresh:boolean)=>{
        this.setState({isRefreshButtonClicked: isRefresh});
    }

    render() {
        return (
            <LightModePageTemplate>
                <SideBarTemplate isFixedDesktopOnly={true}>
                    <QueryGridSidePanel
                        onApplyButtonClick={this.onApplyButtonClick}
                        serviceTypeId=""
                        clientId=""
                        venueId="" />
                    <BulletinPanel />
                </SideBarTemplate>
                <div className="page-content--with-sidebar-hidden-mobile">
                    <header className="grid-info mt-3 mb-3">
                        <GridTitleCard title="Queries" cardStyle="admin" icon={faUserCog}/>
                    </header>
                    <div className="grid-info__button-container text-center text-lg-left">
                        <Link
                            className={"btn btn-primary btn--large col-12 col-sm-6 col-xl-3 mb-3"}
                            to={
                                {
                                    pathname: "/QueryManageForm",
                                    state: {
                                        id: "",
                                        isView: false
                                    },
                                }
                            }
                        >
                            <span className="btn__icon">
                                <FontAwesomeIcon icon={faPlusCircle} />
                            </span>
                            Add General Query
                        </Link>
                        <button
                            className="status-flow__refresh-shiftbutton btn gig-icon-btn"
                            aria-label="Refresh the current billing status"
                            onClick={()=>this.onRefresh(true)}
                        >
                            <FontAwesomeIcon icon={faSync} />
                        </button>
                    </div>
                    <div className="row">
                        <div className="col-md">
                            {
                                <QueryGrid statusId={this.state.statusId}
                                    serviceTypeId={this.state.serviceId}
                                    venueId={this.state.venueId}
                                    clientId={this.state.clientId} 
                                    location={this.props.location}
                                    raisedById={this.state.raisedById}
                                    onRefresh={this.onRefresh}
                                    isRefreshButtonClicked = {this.state.isRefreshButtonClicked}
                                    />
                            }
                        </div>
                        <div></div>
                    </div>
                </div>
            </LightModePageTemplate>
        );
    }
}

export default withRouter(QueryGridPage);
